import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names, resolving conflicts (last-wins) via tailwind-merge.
 * This is the design system's canonical class-name helper — kept free of any
 * app-specific coupling so it can be consumed anywhere.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
